import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cc403e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arcode-main-toolbar-panel-title" }, " Run and Debug ", -1))
const _hoisted_2 = {
  key: 0,
  class: "run-container"
}
const _hoisted_3 = { class: "form-input" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Network", -1))
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "form-input" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Wallet", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "form-input" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Contract Address", -1))
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "text-right" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "title-data" }, "Input Data", -1))
const _hoisted_15 = {
  key: 0,
  class: "no-results"
}
const _hoisted_16 = { class: "form-radio-linear" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "form-input col-key" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Key", -1))
const _hoisted_22 = ["disabled", "onUpdate:modelValue"]
const _hoisted_23 = { class: "form-input col-value" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Value", -1))
const _hoisted_25 = ["disabled", "onUpdate:modelValue"]
const _hoisted_26 = { class: "form-input col-action" }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { class: "form-input" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Data", -1))
const _hoisted_30 = ["disabled", "value"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "title-data" }, "Tags", -1))
const _hoisted_32 = {
  key: 3,
  class: "no-results"
}
const _hoisted_33 = { class: "form-input col-key" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Name", -1))
const _hoisted_35 = ["disabled", "onUpdate:modelValue"]
const _hoisted_36 = { class: "form-input col-value" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Value", -1))
const _hoisted_38 = ["disabled", "onUpdate:modelValue"]
const _hoisted_39 = { class: "form-input col-action" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "title-data" }, "Interaction options", -1))
const _hoisted_41 = { class: "form-radio" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = ["disabled"]
const _hoisted_44 = ["disabled"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_46 = { class: "" }
const _hoisted_47 = { class: "" }
const _hoisted_48 = { class: "" }
const _hoisted_49 = { class: "" }
const _hoisted_50 = { class: "" }
const _hoisted_51 = { class: "" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "title-data" }, "Balance", -1))
const _hoisted_53 = { class: "run-menu" }
const _hoisted_54 = { class: "text-left-f" }
const _hoisted_55 = { class: "span-balance" }
const _hoisted_56 = { class: "text-right-f" }
const _hoisted_57 = ["disabled"]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add Input Data", -1))
const _hoisted_59 = ["disabled"]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add Tag", -1))
const _hoisted_61 = ["disabled"]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Run Interaction", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Results:", -1))
const _hoisted_64 = {
  key: 4,
  class: "no-results"
}
const _hoisted_65 = {
  key: 5,
  class: "no-results"
}
const _hoisted_66 = { class: "table" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, " Key "),
    /*#__PURE__*/_createElementVNode("th", null, " Value ")
  ])
], -1))
const _hoisted_68 = { style: {"width":"20%"} }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "RAW JSON response:", -1))
const _hoisted_70 = {
  key: 6,
  class: "no-results text-center"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lds-ring lds-ring-small" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Loading ...", -1))
const _hoisted_73 = [
  _hoisted_71,
  _hoisted_72
]
const _hoisted_74 = {
  key: 7,
  class: "run-container text-center-f"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "TX created successfully!", -1))
const _hoisted_76 = { class: "text-center" }
const _hoisted_77 = {
  key: 1,
  class: "run-container text-center-f"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center no-results" }, "Please login first!", -1))

import { ref, reactive, computed, watchEffect, onMounted } from 'vue'
import DefaultIcon from '@/components/atomic/DefaultIcon'
import { ArweaveWrapper, arweaveNetworks, defaultNetwork } from '@/core/ArweaveWrapper'
import { createToast } from 'mosha-vue-toastify'
import { WarpContracts } from '@/core/WarpContracts'
import { Tags } from 'warp-contracts';
import { EvaluationOptions } from 'warp-contracts'

export default /*#__PURE__*/_defineComponent({
  __name: 'RunAndDebug',
  props: {
	workspace: Object,
	tokenState: Object,
	login: Object,
	tx: String,
	iframe: Boolean,
	networkParam: String
},
  setup(__props) {

const props = __props;

const networks = computed(() => {
	return arweaveNetworks
});
const rdFilter = ref('viewState')
const rdInputDataType = ref('input')
const defaultSelNetwork = props.networkParam ? props.networkParam : defaultNetwork
const selNetwork = ref(defaultSelNetwork)
const prevNetwork = ref(selNetwork.value)
const txtContract = ref('')
const response = ref({})
const contractInteractionTX = ref('')
const loadingTX = ref(false)
const txtAllowUnsafeClient = ref(false)
const txtAllowBigInt = ref(false)
const txtInternalWrites = ref(false)
const txtUseArweaveGw = ref(false)
const txtDisableBundling = ref(false)
const txtWaitForConfirmation = ref(false)
// eslint-disable-next-line
const inputList = reactive<{key: string, value: any}[]>([{ key: 'function', value: '' }])
const inputListJSON = computed(() => {
	return JSON.stringify(inputList)
});
const tagsList = reactive<Tags>([])


const mainAddress = ref(props.login.mainAddress)
const balance = ref('0')
/*
const balances = computed(() => {
	const balances = props.tokenState.balances ? props.tokenState.balances : {}
	return balances
});
*/
const isBridgeActive = ref(false)

const inputDataChange = (event) => {
	try{
		const data = JSON.parse(event.target.value) || []
		if (Array.isArray(data) && data) {
			inputList.splice(0, inputList.length)
			for (const e of data) {
				inputList.push(e);
			}
		}
	} catch (error) {
		createToast(`Error: ${error}`,
    {
      type: 'danger',
      showIcon: true,
      position: 'bottom-right',
    })
	}
};

const runInteraction = async (
	contractTX: string,
	// eslint-disable-next-line
	data: any[],
	interaction: string,
	tags: Tags) => {
	loadingTX.value = true
	const options: Partial<EvaluationOptions> = {
		allowUnsafeClient: txtAllowUnsafeClient.value,
		allowBigInt: txtAllowBigInt.value,
		internalWrites: txtInternalWrites.value,
		waitForConfirmation: txtWaitForConfirmation.value
	}
	try {

		const arweaveWrapper = new ArweaveWrapper(selNetwork.value)
		const arweave = arweaveWrapper.arweave
		const customGw = ''
		const useArweaveGw = txtUseArweaveGw.value
		const disableBundling = txtDisableBundling.value
		const warp = new WarpContracts(arweave, customGw, useArweaveGw)
		// Iframe fix
		const loginMethod = props.login.method
		if (isBridgeActive.value && (loginMethod === 'arconnect' || loginMethod === 'finnie')) {
			props.login.hijackArweavePostAPI(arweave)
		}
		let func = ''
		const fullPayload = {}
		response.value = {}
		contractInteractionTX.value = ''
		for (const d of data) {
			let value = d.value
			if (!isNaN(value)) {
				if (Number.isInteger(value)) {
					value = parseInt(value)
				} else {
					value = parseFloat(value)
				}
			}
			if (d.key === 'function') {
				func = value
			}
			fullPayload[d.key] = value
		}
		if (!func) {
			throw Error('Please provide a "function" input.')
		}

		// Check balance
		if (balance.value == 0 &&
				interaction !== 'viewState' &&
				disableBundling == true) {
			throw Error('Not enough balance!')
		}

		const contract = warp.warp.contract(
				contractTX
			).connect(
				props.login.key
			).setEvaluationOptions(options)	

		// Dry-run
		// eslint-disable-next-line
		const handlerResult = await contract.callContract<any>(
			fullPayload, undefined, undefined, tags
		)
		console.log('handle', handlerResult)
    if (handlerResult.type !== 'ok') {
      throw Error(`Cannot create interaction: ${handlerResult.errorMessage}`)
    }

		// View interaction with user's key 
		if (interaction === 'viewState') {
			// eslint-disable-next-line
			const { result } = await contract.viewState<any, any>(fullPayload)
			response.value = result
			createToast('Success on viewState interaction!',
			{
				type: 'success',
				showIcon: true,
				position: 'bottom-right',
			})
		}
		// Write interaction (Dry-run)
		else if (interaction === 'writeInteractionDryRun') {
			// eslint-disable-next-line
      const result = await contract.dryWrite<any>(fullPayload)
			response.value = result
			createToast('Interaction executed successfully!',
			{
				type: 'success',
				showIcon: true,
				position: 'bottom-right',
			})
		}
		// Write interaction
		else if (interaction === 'writeInteraction') {
      contractInteractionTX.value = await contract.writeInteraction(fullPayload, { tags: tags, disableBundling: disableBundling } )
			createToast('TX created successfully!',
			{
				type: 'success',
				showIcon: true,
				position: 'bottom-right',
			})
		}
		
	} catch (err) {
		let error = `${err}`
		if (typeof(err) === 'object' &&
				Object.prototype.hasOwnProperty.call(err, 'message')) {
			error = err.message
		}
		createToast(error,
    {
      type: 'danger',
      showIcon: true,
      position: 'bottom-right',
    })
		console.error(error)
	}
	loadingTX.value = false
}
const addInputData = (key: string, value: string) => {
	inputList.push({ key, value })
}

const removeInputAction = (index: number) => {
	inputList.splice(index, 1)
}

const addTag = (name: string, value: string) => {
	tagsList.push({ name, value })
}

const removeTag = (index: number) => {
	tagsList.splice(index, 1)
}

const testnetMintTokens = async (qty='1000000000000') => {
	try {
		const net = networks.value[selNetwork.value]
		const url = `${net.protocol}://${net.host}:${net.port}/mint/${mainAddress.value}/${qty}`
		const res = await fetch(url)
		if (res.status === 200) {
		createToast('Tokens minted!',
			{
				type: 'success',
				showIcon: true,
				position: 'bottom-right',
			})
		} else {
			console.log('Error:', res)
			createToast('Tokens not minted!',
			{
				type: 'danger',
				showIcon: true,
				position: 'bottom-right',
			})
		}

		// Update balance after 1 second 
		window.setTimeout(async () => {
			const arweave = new ArweaveWrapper(selNetwork.value)
			balance.value = await arweave.arweave.wallets.getBalance(mainAddress.value)
			balance.value = arweave.arweave.ar.winstonToAr(balance.value)
		}, 1500)


	} catch (err) {
		createToast(err,
    {
      type: 'danger',
      showIcon: true,
      position: 'bottom-right',
    })
	}
}

onMounted(async () => {
	// Get wallet balance
	if (mainAddress.value) {
		balance.value = 0
		try {
			const arweave = new ArweaveWrapper(selNetwork.value)
			balance.value = await arweave.arweave.wallets.getBalance(mainAddress.value)
			balance.value = arweave.arweave.ar.winstonToAr(balance.value)
			prevNetwork.value = selNetwork.value
		} catch (err) {
			createToast(`${err}`,
			{
				type: 'danger',
				showIcon: true,
				position: 'bottom-right',
			})
		}
	}
	// Check iframe conditions
	isBridgeActive.value = false
	if (props.iframe) {
		// Start handshake with parent 
		try {
			isBridgeActive.value = await props.login.isBridgeActive()

		} catch (err) {
			createToast(`${err}`,
			{
				type: 'danger',
				showIcon: true,
				position: 'bottom-right',
			})
		}
	}
})

watchEffect(async () => {
	// Balance for Method 1
	if (mainAddress.value && selNetwork.value != prevNetwork.value) {
		balance.value = 0
		try {
			const arweave = new ArweaveWrapper(selNetwork.value)
			balance.value = await arweave.arweave.wallets.getBalance(mainAddress.value)
			balance.value = arweave.arweave.ar.winstonToAr(balance.value)
			prevNetwork.value = selNetwork.value
		} catch (err) {
			createToast(`${err}`,
			{
				type: 'danger',
				showIcon: true,
				position: 'bottom-right',
			})
		}
	}
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (mainAddress.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _withDirectives(_createElementVNode("select", {
              disabled: loadingTX.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selNetwork).value = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(networks), (nItem, nIndex) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: nIndex,
                  value: nIndex
                }, _toDisplayString(nItem.host) + " (" + _toDisplayString(nIndex) + ")", 9, _hoisted_6))
              }), 128))
            ], 8, _hoisted_5), [
              [
                _vModelSelect,
                selNetwork.value,
                void 0,
                { trim: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("input", {
              type: "text",
              disabled: "",
              value: mainAddress.value
            }, null, 8, _hoisted_9)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              disabled: loadingTX.value,
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((txtContract).value = $event))
            }, null, 8, _hoisted_12), [
              [
                _vModelText,
                txtContract.value,
                void 0,
                { trim: true }
              ]
            ]),
            _createElementVNode("div", _hoisted_13, [
              (__props.tx)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "link",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (txtContract.value = __props.tx))
                  }, "Use TX from URL"))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_14,
          (!inputList.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_15, "No input data."))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                disabled: loadingTX.value,
                name: "inputDataType",
                value: "input",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((rdInputDataType).value = $event))
              }, null, 8, _hoisted_17), [
                [
                  _vModelRadio,
                  rdInputDataType.value,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createTextVNode(" Input fields ")
            ]),
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                disabled: loadingTX.value,
                name: "inputDataType",
                value: "json",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((rdInputDataType).value = $event))
              }, null, 8, _hoisted_18), [
                [
                  _vModelRadio,
                  rdInputDataType.value,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createTextVNode(" Raw json ")
            ])
          ]),
          (rdInputDataType.value === 'input')
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inputList, (iL, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "data-input-list",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _withDirectives(_createElementVNode("input", {
                        disabled: loadingTX.value,
                        type: "text",
                        "onUpdate:modelValue": ($event: any) => ((iL.key) = $event)
                      }, null, 8, _hoisted_22), [
                        [
                          _vModelText,
                          iL.key,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _withDirectives(_createElementVNode("input", {
                        disabled: loadingTX.value,
                        type: "text",
                        "onUpdate:modelValue": ($event: any) => ((iL.value) = $event)
                      }, null, 8, _hoisted_25), [
                        [
                          _vModelText,
                          iL.value,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_unref(DefaultIcon), {
                        onClick: ($event: any) => (removeInputAction(index)),
                        class: "icon-action",
                        icon: "codicon-trash"
                      }, null, 8, ["onClick"])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (rdInputDataType.value === 'json')
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("textarea", {
                    rows: "6",
                    disabled: loadingTX.value,
                    value: _unref(inputListJSON),
                    onChange: inputDataChange
                  }, null, 40, _hoisted_30)
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_31,
          (!tagsList.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_32, "No tags."))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagsList, (tL, indexTag) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "data-input-list",
              key: indexTag
            }, [
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _withDirectives(_createElementVNode("input", {
                  disabled: loadingTX.value,
                  type: "text",
                  "onUpdate:modelValue": ($event: any) => ((tL.name) = $event)
                }, null, 8, _hoisted_35), [
                  [
                    _vModelText,
                    tL.name,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _withDirectives(_createElementVNode("input", {
                  disabled: loadingTX.value,
                  type: "text",
                  "onUpdate:modelValue": ($event: any) => ((tL.value) = $event)
                }, null, 8, _hoisted_38), [
                  [
                    _vModelText,
                    tL.value,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createVNode(_unref(DefaultIcon), {
                  onClick: ($event: any) => (removeTag(indexTag)),
                  class: "icon-action",
                  icon: "codicon-trash"
                }, null, 8, ["onClick"])
              ])
            ]))
          }), 128)),
          _hoisted_40,
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                disabled: loadingTX.value,
                name: "runFilter",
                value: "viewState",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((rdFilter).value = $event))
              }, null, 8, _hoisted_42), [
                [
                  _vModelRadio,
                  rdFilter.value,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createTextVNode(" View state ")
            ]),
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                disabled: loadingTX.value,
                name: "runFilter",
                value: "writeInteractionDryRun",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((rdFilter).value = $event))
              }, null, 8, _hoisted_43), [
                [
                  _vModelRadio,
                  rdFilter.value,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createTextVNode(" Write Interaction (Dry-run only) ")
            ]),
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                disabled: loadingTX.value,
                name: "runFilter",
                value: "writeInteraction",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((rdFilter).value = $event))
              }, null, 8, _hoisted_44), [
                [
                  _vModelRadio,
                  rdFilter.value,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createTextVNode(" Write Interaction (Create and Post TX) ")
            ]),
            _hoisted_45,
            _createElementVNode("label", _hoisted_46, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((txtUseArweaveGw).value = $event)),
                type: "checkbox"
              }, null, 512), [
                [
                  _vModelCheckbox,
                  txtUseArweaveGw.value,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createTextVNode(" useArweaveGw (Instead of Warp Gw) ")
            ]),
            _createElementVNode("label", _hoisted_47, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((txtDisableBundling).value = $event)),
                type: "checkbox"
              }, null, 512), [
                [
                  _vModelCheckbox,
                  txtDisableBundling.value,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createTextVNode(" disableBundling (default = false) ")
            ]),
            _createElementVNode("label", _hoisted_48, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((txtWaitForConfirmation).value = $event)),
                type: "checkbox"
              }, null, 512), [
                [
                  _vModelCheckbox,
                  txtWaitForConfirmation.value,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createTextVNode(" waitForConfirmation (the write will wait for the transaction to be confirmed when true) ")
            ]),
            _createElementVNode("label", _hoisted_49, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((txtAllowUnsafeClient).value = $event)),
                type: "checkbox"
              }, null, 512), [
                [
                  _vModelCheckbox,
                  txtAllowUnsafeClient.value,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createTextVNode(" allowUnsafeClient (Insecure) ")
            ]),
            _createElementVNode("label", _hoisted_50, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((txtAllowBigInt).value = $event)),
                type: "checkbox"
              }, null, 512), [
                [
                  _vModelCheckbox,
                  txtAllowBigInt.value,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createTextVNode(" allowBigInt ")
            ]),
            _createElementVNode("label", _hoisted_51, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((txtInternalWrites).value = $event)),
                type: "checkbox"
              }, null, 512), [
                [
                  _vModelCheckbox,
                  txtInternalWrites.value,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createTextVNode(" internalWrites ")
            ])
          ]),
          _hoisted_52,
          _createElementVNode("ul", _hoisted_53, [
            _createElementVNode("li", null, [
              _createElementVNode("p", _hoisted_54, [
                _createElementVNode("span", _hoisted_55, _toDisplayString(balance.value), 1),
                _createTextVNode(" AR ")
              ])
            ]),
            _createElementVNode("li", _hoisted_56, [
              (selNetwork.value.indexOf('localhost') >= 0 || selNetwork.value.indexOf('testnet') >= 0)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "link",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (testnetMintTokens()))
                  }, "+ Mint 1 AR"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: _normalizeClass({primary: !loadingTX.value}),
                disabled: loadingTX.value,
                onClick: _cache[15] || (_cache[15] = ($event: any) => (addInputData('', '')))
              }, [
                _createVNode(_unref(DefaultIcon), {
                  class: "icon-btn",
                  icon: "codicon-add"
                }),
                _hoisted_58
              ], 10, _hoisted_57)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: _normalizeClass({primary: !loadingTX.value}),
                disabled: loadingTX.value,
                onClick: _cache[16] || (_cache[16] = ($event: any) => (addTag('', '')))
              }, [
                _createVNode(_unref(DefaultIcon), {
                  class: "icon-btn",
                  icon: "codicon-tag"
                }),
                _hoisted_60
              ], 10, _hoisted_59)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: _normalizeClass({primary: (txtContract.value) && !loadingTX.value}),
                disabled: (!txtContract.value) || loadingTX.value,
                onClick: _cache[17] || (_cache[17] = ($event: any) => (runInteraction(
					txtContract.value, inputList, rdFilter.value, tagsList
				)))
              }, [
                _createVNode(_unref(DefaultIcon), {
                  class: "icon-btn",
                  icon: "codicon-debug-alt"
                }),
                _hoisted_62
              ], 10, _hoisted_61)
            ])
          ]),
          _hoisted_63,
          (!response.value || (response.value && Object.keys(response.value).length == 0) && !loadingTX.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_64, " No results. "))
            : _createCommentVNode("", true),
          (response.value && Object.keys(response.value).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                _createElementVNode("table", _hoisted_66, [
                  _hoisted_67,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(response.value), (k) => {
                      return (_openBlock(), _createElementBlock("tr", { key: k }, [
                        _createElementVNode("td", _hoisted_68, _toDisplayString(k), 1),
                        _createElementVNode("td", null, _toDisplayString(response.value[k]), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _hoisted_69,
                _createElementVNode("pre", null, _toDisplayString(response.value), 1)
              ]))
            : _createCommentVNode("", true),
          (loadingTX.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_70, _hoisted_73))
            : _createCommentVNode("", true),
          (contractInteractionTX.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                _createVNode(_unref(DefaultIcon), {
                  class: "icon-run-panel success",
                  icon: "codicon-check"
                }),
                _hoisted_75,
                _createElementVNode("p", _hoisted_76, "TX: " + _toDisplayString(contractInteractionTX.value), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_77, [
          _createVNode(_unref(DefaultIcon), {
            class: "icon-run-panel",
            icon: "codicon-lock"
          }),
          _hoisted_78
        ]))
  ], 64))
}
}

})